/**
 * i18n bootstrap — Hebrew (default) + English.
 *
 * Usage:
 *   import { useTranslation } from "react-i18next";
 *   const { t } = useTranslation();
 *   t("nav.beit_midrash") // → "בית המדרש שלי" / "My Beit Midrash"
 *
 * Language is persisted to localStorage via LanguageContext.
 * Detection order: explicit user choice (localStorage) → "he" fallback.
 * We deliberately do NOT auto-detect the browser language — this is a
 * sacred Hebrew-first app and Hebrew must be the default for everyone
 * unless they explicitly switch to English.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import he from "./locales/he.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      he: { translation: he },
      en: { translation: en },
    },
    lng: (() => {
      try {
        const saved = typeof window !== "undefined" && window.localStorage.getItem("torahya_lang");
        return saved === "en" ? "en" : "he";
      } catch {
        return "he";
      }
    })(),
    fallbackLng: "he",
    supportedLngs: ["he", "en"],
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "torahya_lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false }, // React already escapes
    returnEmptyString: false,
  });

export default i18n;
